import { render, staticRenderFns } from "./OptionsMenuComponent.vue?vue&type=template&id=04fde360&scoped=true"
import script from "./OptionsMenuComponent.vue?vue&type=script&lang=js"
export * from "./OptionsMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./OptionsMenuComponent.vue?vue&type=style&index=0&id=04fde360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fde360",
  null
  
)

export default component.exports